import { navigationStateActions } from '.';

export const { setState, removeState, resetState, updateState, clearStaleStates } = navigationStateActions;
